import CustomComponent from '../CustomComponent';

import { convertStyleData } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './StaticVesselCustomComponent.less';

export default function StaticVesselCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;               // 组件数据
  const detailData = props.detailData;   // 详情页数据
  const dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(props.data.style);
  /**
   * 组件内容处理
   */   
  let content = data.content;
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component static-vessel" style={styleObj} onClick={() => customEvent({customFeature})}>
      {content.map((componentData, componentIndex) => 
        <CustomComponent key={componentIndex} index={componentIndex} data={componentData} detailData={detailData} dynamicData={dynamicData} />
      )}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/static-vessel-custom-component/StaticVesselCustomComponent.jsx